export interface OptionSelect {
  id: string;
  name: string;
}
export interface ObjectSearchMain {
  pageIndex: number;
  pageSize: number;
  keyword?: string;
  startDate?: string;
  endDate?: string;
}

export interface IDanhSachDanhMuc {
  provinces: any[];
  districts: any[];
  subDistricts: any[];
  listDoiTuong: any[];
  listGioiTinh: any[];
  listNgheNghiep: any[];
  listLDKham: any[];
  listQuocTich: any[];
  listDanToc: any[];
  listDKKham: any[];
  listPhongKham: any[];
  listDVKhamBenh: any[];
  listTuyenKCB?: any[];
  listICD10: any[];
  listHTXT: any[];
  listKQDT: any[];
  listDichVu: any[];
}

export interface iUploadImage {
  files: any;
  isEmpty: boolean;
  src: any;
  formData: any;
}

export interface IItemMenu {
  code: string;
  name: string;
  action: (value: IItemMenu) => void;
}

export interface IItemMenuGroup {
  groupName: string;
  listItem: IItemMenu[];
}

export enum FILE_TYPE {
  PDF = "pdf",
  DOC = "doc",
  DOCX = "docx",
  XLS = "xls",
  XLSX = "xlsx",
  JPG = "jpg",
  JPEG = "jpeg",
  PNG = "png",
  BMP = "bmp",
  SVG = "svg",
  TXT = "txt",
  CSV = "csv",
}

export interface IFile {
  id: string;
  name: string;
}

export interface IViewFile {
  open: boolean;
  file: {
    id: string;
    name: string;
    type?: string;
    url: string;
  } | null;
}

export interface IObject {[key: string]: any}
